import React from 'react';

interface PhotoModalProps {
  photoSrc: string;
  onClose: () => void;
}

const PhotoModal: React.FC<PhotoModalProps> = ({ photoSrc, onClose }) => {
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="photo-modal active" onClick={handleBackdropClick}>
      <span className="photo-modal-close" onClick={onClose}>
        &times;
      </span>
      <img src={photoSrc} alt="Homework Photo" />
    </div>
  );
};

export default PhotoModal;